import React, { useState } from "react";
import "./TryIt.css";
import Generative from "../Generative/Generative";
import Aicard from "../Aicard/Aicard";
import { aicardInfo } from "../Aicard/aicardInfo";
import { BACKEND_URL } from "../../utils/serverUtils";

const TryIt = () => {
  const [displayCount, setDisplayCount] = useState(2);
  const [search, setSearch] = useState("");

  const handleSubmit = () => {
    if (search.trim() === "") return;

    sendRequest(search);
    setSearch("");

  }

  const sendRequest = (data) => {
    fetch(`${BACKEND_URL}/knowledge/send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ question: data }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      });
  };
  return (
    <div className="try">
      <div className="try__container">
        <h1 className="try__title">Try It Yourself!</h1>
        <p className="try__text">
          Please enter the questions in the input below.
        </p>
        <div className="try__input">
          <input
            className="try__search"
            id="searchWidgetTrigger"
            type="text"
            placeholder="Start typing here…"
            value={search}
            onChange={({target}) => setSearch(target.value)}
            onKeyDown={({key}) => {
              if (key === 'Enter') {
                handleSubmit(search);
              }
            }}
            // onKeyDown={onEnterPress}
          />
          {/* <div 
            className="try__btn-wrap"
            onClick={handleSubmit}
          >
            <button className="try__button">Submit</button>
          </div> */}
        </div>
        {/* <p className="try__result">Results (12)</p>
        <Generative />
        {aicardInfo.slice(0, displayCount).map((item, index) => (
          <Aicard key={index} {...item} />
        ))}
        <div className="try__btn">
          {aicardInfo.length > displayCount && (
            <button
              onClick={() => setDisplayCount((prevCount) => prevCount + 2)}
              className="try__show"
            >
              Show More
            </button>
          )}
        </div>  */}
      </div>
    </div>
  );
};

export default TryIt;
